import { gql } from '@apollo/client'

export const GET_REFERRAL_SYSTEM_PLAN = gql`
    query getReferralSystem($filter: ReferralSystemFilterInput, $page: PageInput!) {
                getReferralSystem(filter: $filter, page: $page) {
                    code
                    success
                    message
                    total_count
                    referral_systems {
                        id
                        validity
                        config
                        route_type 
                        discount_status
                        user_audit {
                            created_date
                            created_by
                            modified_date
                            modified_by
                        }
                    }
                }
            }
`
